import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";
import { analytics } from "./index";
import { AnalyticsEvent } from "./events";

/** CLS is a unitless score typically under 1 — GA's event params are integers, so it's reported
 *  in thousandths (a CLS of 0.05 becomes 50) rather than truncated to zero. */
function send(metric: Metric): void {
  const value = metric.name === "CLS" ? Math.round(metric.value * 1000) : Math.round(metric.value);
  analytics.track(AnalyticsEvent.WebVital, {
    metric_name: metric.name,
    value,
    rating: metric.rating,
  });
}

/**
 * Wires Core Web Vitals into analytics once consent is granted. This reports what real visitors
 * on real devices and connections experience — the same metrics Search Console and PageSpeed
 * Insights use — rather than a single lab measurement taken once at deploy time.
 *
 * Called once from lib/consent.tsx when analytics consent is first granted.
 */
export function reportWebVitals(): void {
  onCLS(send);
  onFCP(send);
  onINP(send);
  onLCP(send);
  onTTFB(send);
}
